<div class="product-detail-container">
    <div class="content container">
        <div class="top-section">
            <mat-icon svgIcon="arrowleft" class="left-arrow-icon" (click)="goBack()"></mat-icon>
        </div>

        @if (loading) {
        <mat-spinner class="loading-spinner" [diameter]="70"></mat-spinner>
        } @else { @if (productDetail) {
        <div class="bottom-section">
            <div class="left-section">
                <app-block-details-component
                    [shapeJson]="shapeJson"
                    [selectedColor]="selectedColor"
                    [resetSelectedOption]="resetSelectedOption"
                    (faceColor)="getFaceColors($event)"
                    (seletedchoice)="getSeletedChoice($event)"
                    *ngIf="isCategoryBuyBlock"
                ></app-block-details-component>
                <app-product-image-gallery
                    [show360View]="true"
                    [productId]="productId"
                    *ngIf="!isCategoryBuyBlock"
                ></app-product-image-gallery>
            </div>

            <div class="right-section">
                <p class="product-name font-poppins">{{ productDetail.name }}</p>

                <div class="block-count-container">
                    <span class="icon-section">
                        <mat-icon svgIcon="block" class="icon"></mat-icon>
                        <span class="block-count">{{ productDetail.modelQuantityJson?.totalBlock || 1 }}</span>
                    </span>

                    <span class="icon-section">
                        <mat-icon svgIcon="age" class="icon"></mat-icon>
                        <span class="block-count">Age 4+</span>
                    </span>

                    <span class="icon-section">
                        <mat-icon svgIcon="assemble" class="icon"></mat-icon>
                        <span class="block-count">DIY Build</span>
                    </span>

                    <span class="icon-section">
                        <mat-icon svgIcon="color" class="icon"></mat-icon>
                        <span class="block-count">Mutlicolor</span>
                    </span>
                </div>

                @if (productDetail.description) {
                <div class="description-container">
                    <p class="description">{{ productDetail.description }}</p>
                </div>
                }

                <div class="price-info">
                    @if (productDetail.discountedPrice) {
                    <p class="discounted-price font-poppins">
                        {{ productDetail.discountedPrice | currency: "INR" }}
                    </p>
                    <p class="price">
                        {{ productDetail.price | currency: "INR" }}
                    </p>
                    <p class="offer">
                        {{ productDetail.discountPercentage }}%
                        {{ "productOffer.off" | translate }}
                    </p>
                    } @else {
                    <p class="discounted-price font-poppins">
                        {{ productDetail.price | currency: "INR" }}
                    </p>
                    }
                </div>

                <p class="tax">{{ "productDetails.taxesMessage" | translate }}</p>

                @if (isCategoryBuyBlock) {
                <div class="color-container">
                    <p class="color-heading font-poppins">{{ "productDetails.selectColor" | translate }}</p>
                    <p></p>
                    <div class="color-content">
                        @for (color of colors; track color) {
                        <div
                            class="color-box"
                            [ngStyle]="{ 'background-color': color.value }"
                            [class.active]="color.value === selectedColor"
                            (click)="getSelectedColor(color.value)"
                        ></div>
                        }
                    </div>
                </div>
                } @if (isCategoryBuyBlock) {
                <p class="quantity-heading font-poppins">Quantity</p>
                <div class="quantity-counter">
                    <button class="decrement" (click)="onClick(-1)">-</button>
                    <input
                        type="number"
                        class="input-quantity"
                        [(ngModel)]="quantity"
                        (input)="onInputChange($event, productDetail)"
                        (blur)="checkQuantity(productDetail)"
                    />
                    <button class="increment" (click)="onClick(1)" [disabled]="quantity >= 99">+</button>
                </div>
                }

                <div class="button-container">
                    <button
                        mat-flat-button
                        class="btn-primary-gradient add-btn"
                        (click)="isProductInCart && !isCategoryBuyBlock ? goToCart() : addToCart()"
                    >
                        <mat-icon svgIcon="cart" class="icon"></mat-icon>
                        {{ !isCategoryBuyBlock && isProductInCart ? "Go To Cart" : "Add to Cart" }}
                    </button>

                    <div class="wishlist-buy-now-btn-container">
                        @if (!isCategoryBuyBlock) {
                        <button mat-flat-button class="wishlist-btn" (click)="toggleFavorite(productDetail)">
                            @if (isInWishlist(productDetail)) {
                            <mat-icon [svgIcon]="'activewishlist'" class="active"></mat-icon>
                            } @else {
                            <mat-icon [svgIcon]="'wishlist'" class="wishlist-icon"></mat-icon>
                            } Wishlist
                        </button>
                        }

                        <button
                            mat-flat-button
                            class="buy-now-btn"
                            [disabled]="isLoading"
                            (click)="onClickBuy(productDetail.id, quantity, productDetail)"
                        >
                            <mat-icon svgIcon="buynow" class="icon"></mat-icon>
                            Buy Now
                        </button>
                    </div>

                    <div class="delivery-container">
                        <div class="title-container">
                            <mat-icon svgIcon="delivery" class="truck-icon"></mat-icon>
                            <p class="delivery-title font-poppins">Delivery Options</p>
                        </div>

                        <div class="pincode-container">
                            <mat-form-field
                                class="pincode-field dense-3 input-border-radius"
                                appearance="outline"
                                subscriptSizing="dynamic"
                            >
                                <input matInput type="text" [value]="pinCode" placeholder="Enter Pincode" />
                                <mat-icon matPrefix svgIcon="location" class="location-icon"></mat-icon>
                            </mat-form-field>

                            <button mat-flat-button class="check-btn">Check</button>
                        </div>

                        <div class="estimated-container">
                            <span class="delivery-label">Delivery By</span>
                            <span class="delivery-date">{{ deliveryDate | date: "EEE dd MMM yyyy" }}</span>
                        </div>

                        <p class="delivery-info delivery">
                            <mat-icon svgIcon="onlinepay" class="payment-icon"></mat-icon>
                            <span>Pay on Delivery Available</span>
                        </p>

                        <p class="delivery-info">
                            <mat-icon svgIcon="return" class="return-icon"></mat-icon>
                            <span>Easy 7 Day Returns & Exchange</span>
                        </p>
                    </div>

                    @if (!isCategoryBuyBlock) {
                    <div class="view-designer">
                        <div class="icon-text-container">
                            <div class="icon-container">
                                <mat-icon svgIcon="structure" class="designer-icon"></mat-icon>
                            </div>

                            <div class="text-container">
                                <p class="designer-title font-poppins">View in 3D Designer</p>
                                <p class="designer-subtitle">See how it looks before you buy</p>
                            </div>
                        </div>

                        <mat-icon svgIcon="rightarrow" class="arrow-icon" (click)="goToStructure()"></mat-icon>
                    </div>
                    }
                </div>
            </div>
        </div>

        <div class="product-details-section">
            <p class="title font-poppins">Product Details</p>

            <div class="product-configuration">
                <div class="section blue-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="block" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Total Blocks</span>
                    </div>

                    <p class="value">{{ productDetail.modelQuantityJson?.totalBlock || 1 }}</p>
                </div>

                <div class="section yellow-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="assemble" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Assembly Required</span>
                    </div>

                    <p class="value">Yes</p>
                </div>

                <div class="section blue-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="structure" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Material Type</span>
                    </div>

                    <p class="value">Plastic</p>
                </div>

                <div class="section yellow-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="color" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Color</span>
                    </div>

                    <p class="value">Multi Color</p>
                </div>

                <div class="section blue-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="dimension" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Dimensions</span>
                    </div>

                    <p class="value">10 x 5 x 15 inches</p>
                </div>

                <div class="section yellow-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="weight" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Item Weight</span>
                    </div>

                    <p class="value">100gm</p>
                </div>

                <div class="section blue-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="flag" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Country of Origin</span>
                    </div>

                    <p class="value">India</p>
                </div>

                <div class="section yellow-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="ideal" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Ideal For</span>
                    </div>

                    <p class="value">Boys & Girls</p>
                </div>

                <div class="section blue-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="age" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Minimum Age</span>
                    </div>

                    <p class="value">4 Years</p>
                </div>

                @if (!isCategoryBuyBlock) {
                <div class="section yellow-gradient">
                    <div class="label-container">
                        <span class="icon-container">
                            <mat-icon svgIcon="block" class="block-icon"></mat-icon>
                        </span>
                        <span class="label">Number of Blocks</span>
                    </div>

                    <p class="value view-count" (click)="viewShapeCount()">View Count</p>
                </div>
                }
            </div>
        </div>
        } @if (ratingProducts && ratingProducts.length) {
        <div class="user-rating-review-container">
            <div class="customer-rating-container">
                <div class="rating-heading-container">
                    <p class="rating-title font-poppins">Customer Ratings</p>

                    <p class="rating-container">
                        <span class="average-rating-count font-poppins">{{ productDetail.averageRating }}</span>
                        <span class="rating-review-container">
                            <span class="rating-star-container">
                                @for (star of getStars(productDetail.averageRating ?? 0); track $index) {
                                <mat-icon
                                    [svgIcon]="star === 'full' ? 'fullstar' : star === 'half' ? 'halfstar' : 'fullstar'"
                                    class="star-icon"
                                    [ngClass]="{
                                        'filled-star': star === 'full',
                                        'half-star': star === 'half'
                                    }"
                                >
                                </mat-icon>
                                }
                            </span>
                            <span class="review-count">{{ productDetail.reviews?.length }} reviews</span>
                        </span>
                    </p>
                </div>
                @for (item of distributionEntries; track $index) {
                <div class="rating-bar-row">
                    <div class="count-rating-content">
                        <span>{{ item[0] }}</span
                        ><mat-icon class="rating-star">star</mat-icon>
                    </div>
                    <div class="bar-container">
                        <div
                            class="bar-filled"
                            [ngStyle]="{ width: (item[1] / ratingProducts.length) * 100 + '%' }"
                        ></div>
                    </div>
                    <span>{{ item[1] }}</span>
                </div>
                }
            </div>

            <div class="customer-reviews-section">
                <div class="title-container">
                    <p class="customer-reviews-title font-poppins">Customer Reviews</p>

                    <span class="view-more" [routerLink]="['/products', productDetail.id, 'reviews']">
                        View More <mat-icon svgIcon="rightarrow" class="arrow-icon"></mat-icon>
                    </span>
                </div>

                <div class="customer-reviews">
                    @for (item of ratingProducts.slice(0, 2); track $index) { @if (item?.review) {
                    <div class="review">
                        <div class="name-profile-container">
                            <img [src]="item.otp?.user?.profileImage" class="profile-image" />
                            <div class="name-rating-container">
                                <span class="name font-poppins">{{ item.name }}</span>
                                <span class="rating-star-container">
                                    <span class="rating-star-container">
                                        @for (star of getStars(item.rating); track $index) {
                                        <mat-icon
                                            [svgIcon]="
                                                star === 'full' ? 'fullstar' : star === 'half' ? 'halfstar' : 'fullstar'
                                            "
                                            class="star-icon"
                                            [ngClass]="{
                                                'filled-star': star === 'full',
                                                'half-star': star === 'half'
                                            }"
                                        >
                                        </mat-icon>
                                        }
                                    </span>
                                </span>
                            </div>
                        </div>
                        <p class="review-text">{{ item.review }}</p>
                    </div>
                    } }
                </div>
            </div>
        </div>
        } @if (!isCategoryBuyBlock) {
        <div class="suggestion-section">
            <p class="suggestion-title font-poppins">You Might Also Like</p>

            @if (suggestedProducts) {
            <div class="suggestion-container">
                @for (item of suggestedProducts;let i = $index; track i) {
                <div class="suggestion-item">
                    <div class="suggestion-image-container">
                        <img
                            class="image"
                            [class]="'product-image-gradient' + ((i % 3) + 1)"
                            [src]="item.images.imagesUrl[0]"
                            alt="Item Image"
                            (click)="onClickProduct(item.id)"
                        />

                        <button
                            mat-icon-button
                            class="wishlist-button icon-button-overlay-remove"
                            (click)="toggleFavorite(item)"
                        >
                            @if (isInWishlist(item)) {
                            <mat-icon [svgIcon]="'activewishlist'" class="active"></mat-icon>
                            } @else {
                            <mat-icon [svgIcon]="'wishlist'" class="wishlist-icon"></mat-icon>
                            }
                        </button>
                    </div>

                    <div class="suggestion-info">
                        <p class="suggestion-name font-poppins" appEllipsis maxWidth="200px">
                            {{ item.name }}
                        </p>
                        <div class="price-info">
                            @if (item.discountedPrice) {
                            <p class="suggestion-price">
                                {{ item.discountedPrice | currency: "INR" }}
                            </p>
                            <p class="suggestion-original-price">
                                {{ item.price | currency: "INR" }}
                            </p>
                            } @else {
                            <p class="suggestion-price">
                                {{ item.price | currency: "INR" }}
                            </p>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        } }
    </div>
</div>
